import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { NAV_LINKS, whatsappLink, WA, MEDIA } from "@/data/content";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (href) => {
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-300 ${
        scrolled ? "bg-[#050505]/80 backdrop-blur-xl border-b border-white/10" : "bg-transparent"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-5 lg:px-8 h-16 lg:h-20 flex items-center justify-between">
        <button
          data-testid="nav-logo"
          onClick={() => go("#home")}
          className="flex items-center gap-3"
        >
          <img src={MEDIA.logo} alt="Fast Life Studio Agency" className="h-10 lg:h-12 w-auto rounded-md" />
          <span className="hidden sm:flex flex-col items-start leading-none">
            <span className="font-display font-semibold text-base lg:text-lg tracking-tight text-white">
              FAST LIFE STUDIO
            </span>
            <span className="font-accent text-[9px] lg:text-[10px] uppercase tracking-[0.35em] text-teal-light/80">
              Il cinema di strada
            </span>
          </span>
        </button>

        <div className="hidden lg:flex items-center gap-7">
          {NAV_LINKS.map((l) => (
            <button
              key={l.href}
              data-testid={`nav-link-${l.href.replace("#", "")}`}
              onClick={() => go(l.href)}
              className="text-sm text-slate-300 hover:text-teal-light transition-colors"
            >
              {l.label}
            </button>
          ))}
        </div>

        <a
          data-testid="nav-cta-consulenza"
          href={whatsappLink(WA.general)}
          target="_blank"
          rel="noopener noreferrer"
          className="hidden lg:inline-flex items-center rounded-full bg-teal px-5 py-2.5 text-sm font-medium text-white hover:bg-teal-light hover:text-[#050505] transition-colors"
        >
          Richiedi una consulenza
        </a>

        <button
          data-testid="nav-mobile-toggle"
          className="lg:hidden text-white p-2"
          onClick={() => setOpen((v) => !v)}
          aria-label="Menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </nav>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden bg-[#050505]/95 backdrop-blur-xl border-b border-white/10 px-5 pb-6 pt-2">
          <div className="flex flex-col gap-1">
            {NAV_LINKS.map((l) => (
              <button
                key={l.href}
                data-testid={`mobile-nav-link-${l.href.replace("#", "")}`}
                onClick={() => go(l.href)}
                className="text-left py-3 text-slate-200 border-b border-white/5"
              >
                {l.label}
              </button>
            ))}
            <a
              href={whatsappLink(WA.general)}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-4 inline-flex justify-center items-center rounded-full bg-teal px-5 py-3 text-sm font-medium text-white"
            >
              Richiedi una consulenza
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
